export const signInAdminFormFields = [
	{ label: "user.email", name: "email", type: "email", required: true, margin: "normal", className: "mt-1 my-sm-3" },
	{ label: "user.password", name: "password", type: "password", required: true, margin: "normal", className: "mt-1 my-sm-3" }
];

export const signInDealerFormFields = [
	{ label: "dealer.tds.passport_id", name: "passport_id", type: "text", required: true, margin: "normal", className: "mt-1 my-sm-3" },
	{ label: "dealer.tds.password", name: "password", type: "hidden", value: "innovation", required: false, margin: "normal", className: "mt-1 my-sm-3" }
];

export const reportQuickVocDealerSearchFormFields = [
	{
		label: "report.quickvoc.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.quickvoc.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	},
	{ label: "dealer.dealer_name", name: "dealer_id", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2", options: [] }
]

export const reportTicketKpiDealerSearchFormFields = [
	{
		label: "report.ticket.kpi.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.ticket.kpi.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	},
	{ label: "dealer.dealer_name", name: "dealer_id", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2", options: [] }
]

export const reportQuickVocSearchFormFields = [
	{
		label: "report.quickvoc.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-3 col-sm-3 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.quickvoc.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-3 col-sm-3 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	},
	{
		label: "dealer.sale_area_code", name: "dealer.sale_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.service_area_code", name: "dealer.service_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.dealer_sales_region", name: "dealer.dealer_sales_region", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_sales_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_sales_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_sales_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_sales_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_sales_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_sales_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.dealer_region", name: "dealer.dealer_region", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_region.G.BANGKOK", value: "G.BANGKOK" },
			{ display: "dealer.dealer_region.CENTRAL", value: "CENTRAL" },
			{ display: "dealer.dealer_region.EAST", value: "EAST" },
			{ display: "dealer.dealer_region.NORTH", value: "NORTH" },
			{ display: "dealer.dealer_region.NORTH-EAST", value: "NORTH-EAST" },
			{ display: "dealer.dealer_region.SOUTH", value: "SOUTH" },
		]
	},
	{
		label: "dealer.dealer_province", name: "dealer.dealer_province", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_province_en", name: "dealer.dealer_province_en", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province_en.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_name", name: "dealer_id", type: "autocomplete", required: false, margin: "normal", className: "col-6 col-lg-9 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_name.all", value: "all" },
		options: []
	}
]


export const reportTicketKpiSearchFormFields = [
	{
		label: "report.ticket.kpi.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-3 col-sm-3 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.ticket.kpi.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-3 col-sm-3 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	},
	{
		label: "dealer.sale_area_code", name: "dealer.sale_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.service_area_code", name: "dealer.service_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.dealer_sales_region", name: "dealer.dealer_sales_region", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_sales_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_sales_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_sales_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_sales_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_sales_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_sales_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.dealer_region", name: "dealer.dealer_region", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_region.G.BANGKOK", value: "G.BANGKOK" },
			{ display: "dealer.dealer_region.CENTRAL", value: "CENTRAL" },
			{ display: "dealer.dealer_region.EAST", value: "EAST" },
			{ display: "dealer.dealer_region.NORTH", value: "NORTH" },
			{ display: "dealer.dealer_region.NORTH-EAST", value: "NORTH-EAST" },
			{ display: "dealer.dealer_region.SOUTH", value: "SOUTH" },
		]
	},
	{
		label: "dealer.dealer_province", name: "dealer.dealer_province", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_province_en", name: "dealer.dealer_province_en", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province_en.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_name", name: "dealer_id", type: "autocomplete", required: false, margin: "normal", className: "col-6 col-lg-9 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_name.all", value: "all" },
		options: []
	}
]

export const reportSaleVocSearchFormFields = [
	{
		label: "report.salevoc.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.salevoc.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	}
]

export const reportSaleVocEntitySearchFormFields = [
	{
		label: "report.salevocentity.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.salevocentity.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	}
]

export const reportSaleVocKpiSearchFormFields = [
	{
		label: "report.salevoc.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-4 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.salevoc.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-4 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	},
	{
		label: "report.salevoc.mode", name: "mode", type: "dropdown", required: true, margin: "normal", className: "col-4 pr-2 mt-0 mb-2",
		options: [
			{ display: "mode.overall", value: "overall" },
			{ display: "mode.qvoc", value: "qvoc" },
			{ display: "mode.callcenter", value: "callcenter" },
		]
	}
]

export const reportSaleHotSheetSearchFormFields = [
	{
		label: "report.hotsheet.showroom.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.hotsheet.showroom.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	}
]

export const reportServiceVocSearchFormFields = [
	{
		label: "report.servicevoc.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.servicevoc.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	}
]

export const reportServiceVocEntitySearchFormFields = [
	{
		label: "report.servicevocentity.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.servicevocentity.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	}
]

export const reportServiceVocKpiSearchFormFields = [
	{
		label: "report.servicevoc.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-4 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.servicevoc.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-4 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	},
	{
		label: "report.servicevoc.mode", name: "mode", type: "dropdown", required: true, margin: "normal", className: "col-4 pr-2 mt-0 mb-2",
		options: [
			{ display: "mode.overall", value: "overall" },
			{ display: "mode.qvoc", value: "qvoc" },
			{ display: "mode.callcenter", value: "callcenter" },
		]
	}
]

export const reportServiceHotSheetSearchFormFields = [
	{
		label: "report.hotsheet.service.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.hotsheet.service.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	}
]

export const reportNotifySearchFormFields = [
	{
		label: "report.quickvoc.month", name: "month", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-3 col-sm-3 pr-2 mt-0 mb-2",
		options: [
			{ display: "month.01", value: "01" },
			{ display: "month.02", value: "02" },
			{ display: "month.03", value: "03" },
			{ display: "month.04", value: "04" },
			{ display: "month.05", value: "05" },
			{ display: "month.06", value: "06" },
			{ display: "month.07", value: "07" },
			{ display: "month.08", value: "08" },
			{ display: "month.09", value: "09" },
			{ display: "month.10", value: "10" },
			{ display: "month.11", value: "11" },
			{ display: "month.12", value: "12" },
		]
	},
	{
		label: "report.quickvoc.year", name: "year", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-3 col-sm-3 pr-2 mt-0 mb-2",
		options: [
			{ display: "year.2025", value: "2025" },
			{ display: "year.2024", value: "2024" },
			{ display: "year.2023", value: "2023" },
			{ display: "year.2022", value: "2022" },
			{ display: "year.2021", value: "2021" },
			{ display: "year.2020", value: "2020" },
			{ display: "year.2019", value: "2019" },
			{ display: "year.2018", value: "2018" },
		]
	},
	{
		label: "dealer.sale_area_code", name: "dealer.sale_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.service_area_code", name: "dealer.service_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.dealer_sales_region", name: "dealer.dealer_sales_region", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_sales_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_sales_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_sales_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_sales_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_sales_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_sales_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.dealer_region", name: "dealer.dealer_region", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_region.G.BANGKOK", value: "G.BANGKOK" },
			{ display: "dealer.dealer_region.CENTRAL", value: "CENTRAL" },
			{ display: "dealer.dealer_region.EAST", value: "EAST" },
			{ display: "dealer.dealer_region.NORTH", value: "NORTH" },
			{ display: "dealer.dealer_region.NORTH-EAST", value: "NORTH-EAST" },
			{ display: "dealer.dealer_region.SOUTH", value: "SOUTH" },
		]
	},
	{
		label: "dealer.dealer_province", name: "dealer.dealer_province", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_province_en", name: "dealer.dealer_province_en", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province_en.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_name", name: "dealer.dealer_id", type: "autocomplete", required: false, margin: "normal", className: "col-6 col-lg-9 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_name.all", value: "all" },
		options: []
	}
]


export const reportPdcaSearchFormShowroomFields = [
	{ label: "ticket.type", name: "type", type: "hidden", required: false },
	{ label: "ticket.search.from_date", name: "from_created_date", type: "date", required: true, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{ label: "ticket.search.to_date", name: "to_created_date", type: "date", required: true, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{
		label: "dealer.dealer_sales_region", name: "dealer.dealer_sales_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_sales_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_sales_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_sales_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_sales_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_sales_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_sales_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.dealer_region", name: "dealer.dealer_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_region.G.BANGKOK", value: "G.BANGKOK" },
			{ display: "dealer.dealer_region.CENTRAL", value: "CENTRAL" },
			{ display: "dealer.dealer_region.EAST", value: "EAST" },
			{ display: "dealer.dealer_region.NORTH", value: "NORTH" },
			{ display: "dealer.dealer_region.NORTH-EAST", value: "NORTH-EAST" },
			{ display: "dealer.dealer_region.SOUTH", value: "SOUTH" },
		]
	},
	{
		label: "dealer.sale_area_code", name: "dealer.sale_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-8 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.dealer_province", name: "dealer.dealer_province", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_province_en", name: "dealer.dealer_province_en", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province_en.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_name", name: "dealer.dealer_id", type: "autocomplete", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_name.all", value: "all" },
		options: []
	}
]

export const reportPdcaSearchFormServiceFields = [
	{ label: "ticket.type", name: "type", type: "hidden", required: false },
	{ label: "ticket.search.from_date", name: "from_created_date", type: "date", required: true, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{ label: "ticket.search.to_date", name: "to_created_date", type: "date", required: true, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{
		label: "dealer.dealer_sales_region", name: "dealer.dealer_sales_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_sales_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_sales_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_sales_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_sales_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_sales_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_sales_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.dealer_region", name: "dealer.dealer_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_region.G.BANGKOK", value: "G.BANGKOK" },
			{ display: "dealer.dealer_region.CENTRAL", value: "CENTRAL" },
			{ display: "dealer.dealer_region.EAST", value: "EAST" },
			{ display: "dealer.dealer_region.NORTH", value: "NORTH" },
			{ display: "dealer.dealer_region.NORTH-EAST", value: "NORTH-EAST" },
			{ display: "dealer.dealer_region.SOUTH", value: "SOUTH" },
		]
	},
	{
		label: "dealer.service_area_code", name: "dealer.service_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-8 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.dealer_province", name: "dealer.dealer_province", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_province_en", name: "dealer.dealer_province_en", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province_en.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_name", name: "dealer.dealer_id", type: "autocomplete", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_name.all", value: "all" },
		options: []
	}
]

export const ticketSearchFormShowroomFields = [
	{ label: "ticket.type", name: "type", type: "hidden", required: false },
	{ label: "ticket.search.from_date", name: "from_created_date", type: "date", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{ label: "ticket.search.to_date", name: "to_created_date", type: "date", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{ label: "ticket.search.case_no", name: "case_no", type: "text", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{ label: "ticket.search.tel", name: "tel", type: "text", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{
		label: "ticket.status", name: "status", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-3 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "ticket.status.all", value: "all" },
		options: [
			{ display: "ticket.status.W", value: "W" },
			{ display: "ticket.status.C", value: "C" },
			{ display: "ticket.status.S", value: "S" },
			{ display: "ticket.status.T", value: "T" },
			{ display: "ticket.status.B", value: "B" },
			{ display: "ticket.status.B-", value: "B-" }
		]
	},
	{
		label: "dealer.dealer_sales_region", name: "dealer.dealer_sales_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_sales_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_sales_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_sales_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_sales_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_sales_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_sales_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.dealer_region", name: "dealer.dealer_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_region.G.BANGKOK", value: "G.BANGKOK" },
			{ display: "dealer.dealer_region.CENTRAL", value: "CENTRAL" },
			{ display: "dealer.dealer_region.EAST", value: "EAST" },
			{ display: "dealer.dealer_region.NORTH", value: "NORTH" },
			{ display: "dealer.dealer_region.NORTH-EAST", value: "NORTH-EAST" },
			{ display: "dealer.dealer_region.SOUTH", value: "SOUTH" },
		]
	},
	{
		label: "dealer.sale_area_code", name: "dealer.sale_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.dealer_province", name: "dealer.dealer_province", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_province_en", name: "dealer.dealer_province_en", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province_en.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_name", name: "dealer_id", type: "autocomplete", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_name.all", value: "all" },
		options: []
	}
]

export const ticketSearchFormServiceFields = [
	{ label: "ticket.type", name: "type", type: "hidden", required: false },
	{ label: "ticket.search.from_date", name: "from_created_date", type: "date", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{ label: "ticket.search.to_date", name: "to_created_date", type: "date", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{ label: "ticket.search.case_no", name: "case_no", type: "text", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{ label: "ticket.search.tel", name: "tel", type: "text", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{
		label: "ticket.status", name: "status", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-3 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "ticket.status.all", value: "all" },
		options: [
			{ display: "ticket.status.W", value: "W" },
			{ display: "ticket.status.C", value: "C" },
			{ display: "ticket.status.S", value: "S" },
			{ display: "ticket.status.T", value: "T" },
			{ display: "ticket.status.B", value: "B" },
			{ display: "ticket.status.B-", value: "B-" }
		]
	},
	{
		label: "dealer.dealer_sales_region", name: "dealer.dealer_sales_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_sales_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_sales_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_sales_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_sales_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_sales_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_sales_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.dealer_region", name: "dealer.dealer_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_region.G.BANGKOK", value: "G.BANGKOK" },
			{ display: "dealer.dealer_region.CENTRAL", value: "CENTRAL" },
			{ display: "dealer.dealer_region.EAST", value: "EAST" },
			{ display: "dealer.dealer_region.NORTH", value: "NORTH" },
			{ display: "dealer.dealer_region.NORTH-EAST", value: "NORTH-EAST" },
			{ display: "dealer.dealer_region.SOUTH", value: "SOUTH" },
		]
	},
	{
		label: "dealer.service_area_code", name: "dealer.service_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.dealer_province", name: "dealer.dealer_province", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_province_en", name: "dealer.dealer_province_en", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province_en.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_name", name: "dealer_id", type: "autocomplete", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_name.all", value: "all" },
		options: []
	}
]

export const ticketReportStatusSearchFormShowroomFields = [
	{ label: "ticket.type", name: "type", type: "hidden", required: false },
	{ label: "ticket.search.from_date", name: "from_created_date", type: "date", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{ label: "ticket.search.to_date", name: "to_created_date", type: "date", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{
		label: "dealer.dealer_sales_region", name: "dealer.dealer_sales_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_sales_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_sales_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_sales_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_sales_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_sales_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_sales_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.dealer_region", name: "dealer.dealer_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_region.G.BANGKOK", value: "G.BANGKOK" },
			{ display: "dealer.dealer_region.CENTRAL", value: "CENTRAL" },
			{ display: "dealer.dealer_region.EAST", value: "EAST" },
			{ display: "dealer.dealer_region.NORTH", value: "NORTH" },
			{ display: "dealer.dealer_region.NORTH-EAST", value: "NORTH-EAST" },
			{ display: "dealer.dealer_region.SOUTH", value: "SOUTH" },
		]
	},
	{
		label: "dealer.sale_area_code", name: "dealer.sale_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-8 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.dealer_province", name: "dealer.dealer_province", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_province_en", name: "dealer.dealer_province_en", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province_en.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_name", name: "dealer_id", type: "autocomplete", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_name.all", value: "all" },
		options: []
	}
]

export const ticketReportStatusSearchFormServiceFields = [
	{ label: "ticket.type", name: "type", type: "hidden", required: false },
	{ label: "ticket.search.from_date", name: "from_created_date", type: "date", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{ label: "ticket.search.to_date", name: "to_created_date", type: "date", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{
		label: "dealer.dealer_sales_region", name: "dealer.dealer_sales_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_sales_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_sales_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_sales_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_sales_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_sales_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_sales_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.dealer_region", name: "dealer.dealer_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_region.G.BANGKOK", value: "G.BANGKOK" },
			{ display: "dealer.dealer_region.CENTRAL", value: "CENTRAL" },
			{ display: "dealer.dealer_region.EAST", value: "EAST" },
			{ display: "dealer.dealer_region.NORTH", value: "NORTH" },
			{ display: "dealer.dealer_region.NORTH-EAST", value: "NORTH-EAST" },
			{ display: "dealer.dealer_region.SOUTH", value: "SOUTH" },
		]
	},
	{
		label: "dealer.service_area_code", name: "dealer.service_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-8 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.dealer_province", name: "dealer.dealer_province", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_province_en", name: "dealer.dealer_province_en", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province_en.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_name", name: "dealer_id", type: "autocomplete", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_name.all", value: "all" },
		options: []
	}
]

export const ticketReportResponseRateSearchFormShowroomFields = [
	{ label: "ticket.type", name: "type", type: "hidden", required: false },
	{ label: "ticket.search.from_date", name: "from", type: "date", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{ label: "ticket.search.to_date", name: "to", type: "date", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{
		label: "dealer.dealer_sales_region", name: "dealer.dealer_sales_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_sales_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_sales_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_sales_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_sales_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_sales_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_sales_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.dealer_region", name: "dealer.dealer_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_region.G.BANGKOK", value: "G.BANGKOK" },
			{ display: "dealer.dealer_region.CENTRAL", value: "CENTRAL" },
			{ display: "dealer.dealer_region.EAST", value: "EAST" },
			{ display: "dealer.dealer_region.NORTH", value: "NORTH" },
			{ display: "dealer.dealer_region.NORTH-EAST", value: "NORTH-EAST" },
			{ display: "dealer.dealer_region.SOUTH", value: "SOUTH" },
		]
	},
	{
		label: "dealer.sale_area_code", name: "dealer.sale_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-8 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.dealer_province", name: "dealer.dealer_province", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_province_en", name: "dealer.dealer_province_en", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province_en.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_name", name: "dealer_id", type: "autocomplete", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_name.all", value: "all" },
		options: []
	}
]

export const ticketReportResponseRateSearchFormServiceFields = [
	{ label: "ticket.type", name: "type", type: "hidden", required: false },
	{ label: "ticket.search.from_date", name: "from", type: "date", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{ label: "ticket.search.to_date", name: "to", type: "date", required: false, margin: "normal", className: "col-6 col-lg-2 col-md-3 col-sm-3 pr-2 mt-0 mb-2" },
	{
		label: "dealer.dealer_sales_region", name: "dealer.dealer_sales_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_sales_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_sales_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_sales_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_sales_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_sales_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_sales_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.dealer_region", name: "dealer.dealer_region", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_region.G.BANGKOK", value: "G.BANGKOK" },
			{ display: "dealer.dealer_region.CENTRAL", value: "CENTRAL" },
			{ display: "dealer.dealer_region.EAST", value: "EAST" },
			{ display: "dealer.dealer_region.NORTH", value: "NORTH" },
			{ display: "dealer.dealer_region.NORTH-EAST", value: "NORTH-EAST" },
			{ display: "dealer.dealer_region.SOUTH", value: "SOUTH" },
		]
	},
	{
		label: "dealer.service_area_code", name: "dealer.service_area_code", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-8 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{
		label: "dealer.dealer_province", name: "dealer.dealer_province", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_province_en", name: "dealer.dealer_province_en", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_province_en.all", value: "all" },
		options: []
	},
	{
		label: "dealer.dealer_name", name: "dealer_id", type: "autocomplete", required: false, margin: "normal", className: "col-6 col-lg-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_name.all", value: "all" },
		options: []
	}
]

export const ticketServiceFormFields = [
	{
		label: "ticket.validation", name: "validation", type: "switch", required: false, margin: "normal", className: "col-12 text-right pr-2 mt-0 mb-3"
	},
	{ label: "ticket.info.customer", type: "header" },
	{ label: "ticket.title", name: "title", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.name", name: "name", type: "text", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.age", name: "age", type: "number", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2", min: 1 },
	{ label: "ticket.email", name: "email", type: "email", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.tel", name: "tel", type: "text", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.tel_office", name: "tel_office", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.fax", name: "fax", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.fax_office", name: "fax_office", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.address", name: "address", type: "text", required: false, margin: "normal", className: "col-12 col-lg-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.address_office", name: "address_office", type: "text", required: false, margin: "normal", className: "col-12 col-lg-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.info.car", type: "header", className: "mt-3" },
	{ label: "ticket.car_model", name: "car_model", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.chassis_number", name: "chassis_number", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.body_color", name: "body_color", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.registration_number", name: "registration_number", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.job_id", name: "job_id", type: "text", disabled: true, required: false, margin: "normal", className: "col-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.staff_name", name: "staff_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.delivered_date", name: "delivered_date", type: "text", disabled: true, required: false, margin: "normal", className: "col-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.A", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.A01", name: "complaint_categories.A01", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A02", name: "complaint_categories.A02", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A03", name: "complaint_categories.A03", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A04", name: "complaint_categories.A04", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A05", name: "complaint_categories.A05", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A06", name: "complaint_categories.A06", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A07", name: "complaint_categories.A07", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A99", name: "complaint_categories.A99", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-0" },
	{ label: "ticket.complaint_categories.A100", name: "complaint_categories.A100", type: "text", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.F", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.F01", name: "complaint_categories.F01", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.F02", name: "complaint_categories.F02", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.F03", name: "complaint_categories.F03", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.F04", name: "complaint_categories.F04", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.F05", name: "complaint_categories.F05", type: "checkbox", className: "col-12 col-sm-12 col-lg-8 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.F99", name: "complaint_categories.F99", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-0" },
	{ label: "ticket.complaint_categories.F100", name: "complaint_categories.F100", type: "text", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.P", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.P01", name: "complaint_categories.P01", type: "checkbox", className: "col-12 col-sm-12 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.P99", name: "complaint_categories.P99", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-0" },
	{ label: "ticket.complaint_categories.P100", name: "complaint_categories.P100", type: "text", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.O", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.O01", name: "complaint_categories.O01", type: "checkbox", className: "col-12 col-sm-12 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.O99", name: "complaint_categories.O99", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-0" },
	{ label: "ticket.complaint_categories.O100", name: "complaint_categories.O100", type: "text", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_description", name: "complaint_description", type: "textarea", disabled: true, required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.q1", name: "q1", type: "text", disabled: true, required: false, className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.q2", name: "q2", type: "text", disabled: true, required: false, className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_solution", name: "complaint_solution", type: "textarea", required: true, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "dealer", type: "header", className: "mt-3" },
	{ label: "dealer.dealer_name", name: "dealer.dealer_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-12 col-md-6 col-lg-6  pr-2 mt-0 mb-2" },
	{ label: "dealer.branch_name", name: "dealer.branch_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-12 col-md-6 col-lg-6  pr-2 mt-0 mb-2" },
	{ label: "dealer.sale_manager_name", name: "dealer.sale_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{ label: "dealer.service_manager_name", name: "dealer.service_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{ label: "dealer.sale_area_manager_name", name: "dealer.sale_area_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{ label: "dealer.service_area_manager_name", name: "dealer.service_area_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{
		label: "ticket.status", name: "status", type: "dropdown", required: false, margin: "normal", className: "col-12 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{ label: "ticket.cancel_description", name: "cancel_description", type: "textarea", disabled: true, required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
]

export const ticketShowroomFormFields = [
	{
		label: "ticket.validation", name: "validation", type: "switch", required: false, margin: "normal", className: "col-12 text-right pr-2 mt-0 mb-3"
	},
	{ label: "ticket.info.customer", type: "header" },
	{ label: "ticket.title", name: "title", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.name", name: "name", type: "text", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.age", name: "age", type: "number", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2", min: 1 },
	{ label: "ticket.email", name: "email", type: "email", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.tel", name: "tel", type: "text", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.tel_office", name: "tel_office", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.fax", name: "fax", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.fax_office", name: "fax_office", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.address", name: "address", type: "text", required: false, margin: "normal", className: "col-12 col-lg-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.address_office", name: "address_office", type: "text", required: false, margin: "normal", className: "col-12 col-lg-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.info.car", type: "header", className: "mt-3" },
	{ label: "ticket.car_model", name: "car_model", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.chassis_number", name: "chassis_number", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.body_color", name: "body_color", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.registration_number", name: "registration_number", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.staff_name", name: "staff_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.showroom.delivered_date", name: "delivered_date", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.S", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.S01", name: "complaint_categories.S01", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S02", name: "complaint_categories.S02", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S03", name: "complaint_categories.S03", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S04", name: "complaint_categories.S04", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S05", name: "complaint_categories.S05", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S06", name: "complaint_categories.S06", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S07", name: "complaint_categories.S07", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S08", name: "complaint_categories.S08", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S09", name: "complaint_categories.S09", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S10", name: "complaint_categories.S10", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S99", name: "complaint_categories.S99", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-0" },
	{ label: "ticket.complaint_categories.S100", name: "complaint_categories.S100", type: "text", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_description", name: "complaint_description", type: "textarea", disabled: true, required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.q1", name: "q1", type: "text", disabled: true, required: false, className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.q2", name: "q2", type: "text", disabled: true, required: false, className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_solution", name: "complaint_solution", type: "textarea", required: true, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "dealer", type: "header", className: "mt-3" },
	{ label: "dealer.dealer_name", name: "dealer.dealer_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-12 col-md-6 col-lg-6  pr-2 mt-0 mb-2" },
	{ label: "dealer.branch_name", name: "dealer.branch_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-12 col-md-6 col-lg-6  pr-2 mt-0 mb-2" },
	{ label: "dealer.sale_manager_name", name: "dealer.sale_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{ label: "dealer.service_manager_name", name: "dealer.service_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{ label: "dealer.sale_area_manager_name", name: "dealer.sale_area_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{ label: "dealer.service_area_manager_name", name: "dealer.service_area_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{
		label: "ticket.status", name: "status", type: "dropdown", required: false, margin: "normal", className: "col-12 col-lg-4 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: []
	},
	{ label: "ticket.cancel_description", name: "cancel_description", type: "textarea", disabled: true, required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
]

export const ticketLogFormFields = [
	{ label: "ticket.log.updated_date", name: "updated_date", type: "datetime", required: true, margin: "normal", className: "col-6 col-md-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.log.updated_by", name: "updated_by", type: "text", required: true, margin: "normal", className: "col-6 col-md-4 pr-2 mt-0 mb-2" },
	{
		label: "ticket.status", name: "status", type: "dropdown", required: true, margin: "normal", className: "col-6 col-md-4 col-sm-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "ticket.status.W", value: "W" },
			{ display: "ticket.status.C", value: "C" },
			{ display: "ticket.status.S", value: "S" },
			{ display: "ticket.status.T", value: "T" },
			{ display: "ticket.status.B", value: "B" },
		]
	},
]

export const ticketStatusShowroomOptions = [
	{ display: "ticket.status.W", value: "W" },
	{ display: "ticket.status.C", value: "C" },
	{ display: "ticket.status.S", value: "S" },
	{ display: "ticket.status.T", value: "T" },
	{ display: "ticket.status.B", value: "B" }
]

export const ticketStatusServiceOptions = [
	{ display: "ticket.status.W", value: "W" },
	{ display: "ticket.status.C", value: "C" },
	{ display: "ticket.status.S", value: "S" },
	{ display: "ticket.status.T", value: "T" },
	{ display: "ticket.status.B", value: "B" }
]

export const ticketStatusCancelOptions = [
	{ display: "ticket.status.D", value: "D" }
]

export const ticketShowroomAddFormFields = [
	{ label: "ticket.info.customer", type: "header" },
	{ label: "ticket.title", name: "title", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.name", name: "name", type: "text", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.age", name: "age", type: "number", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2", min: 1 },
	{ label: "ticket.email", name: "email", type: "email", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.tel", name: "tel", type: "text", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.tel_office", name: "tel_office", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.fax", name: "fax", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.fax_office", name: "fax_office", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.address", name: "address", type: "text", required: false, margin: "normal", className: "col-12 col-lg-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.address_office", name: "address_office", type: "text", required: false, margin: "normal", className: "col-12 col-lg-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.info.car", type: "header", className: "mt-3" },
	{ label: "ticket.car_model", name: "car_model", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.chassis_number", name: "chassis_number", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.body_color", name: "body_color", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.registration_number", name: "registration_number", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.showroom.delivered_date", name: "delivered_date", type: "date", required: false, margin: "normal", className: "col-12 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.S", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.S01", name: "complaint_categories.S01", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S02", name: "complaint_categories.S02", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S03", name: "complaint_categories.S03", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S04", name: "complaint_categories.S04", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S05", name: "complaint_categories.S05", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S06", name: "complaint_categories.S06", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S07", name: "complaint_categories.S07", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S08", name: "complaint_categories.S08", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S09", name: "complaint_categories.S09", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S10", name: "complaint_categories.S10", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.S99", name: "complaint_categories.S99", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-0" },
	{ label: "ticket.complaint_categories.S100", name: "complaint_categories.S100", type: "text", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_description", name: "complaint_description", type: "textarea", required: true, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "dealer", type: "header", className: "mt-3" },
	{
		label: "dealer.dealer_name", name: "dealer_id", type: "dropdown", required: true, margin: "normal", className: "col-12 pr-2 mt-0 mb-2",
		options: []
	},
	{ label: "dealer.sale_manager_name", name: "dealer.sale_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{ label: "dealer.service_manager_name", name: "dealer.service_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{ label: "dealer.sale_area_manager_name", name: "dealer.sale_area_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{ label: "dealer.service_area_manager_name", name: "dealer.service_area_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
]

export const ticketServiceAddFormFields = [
	{ label: "ticket.info.customer", type: "header" },
	{ label: "ticket.title", name: "title", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.name", name: "name", type: "text", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.age", name: "age", type: "number", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2", min: 1 },
	{ label: "ticket.email", name: "email", type: "email", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.tel", name: "tel", type: "text", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.tel_office", name: "tel_office", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.fax", name: "fax", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.fax_office", name: "fax_office", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.address", name: "address", type: "text", required: false, margin: "normal", className: "col-12 col-lg-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.address_office", name: "address_office", type: "text", required: false, margin: "normal", className: "col-12 col-lg-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.info.car", type: "header", className: "mt-3" },
	{ label: "ticket.car_model", name: "car_model", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.chassis_number", name: "chassis_number", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.body_color", name: "body_color", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.registration_number", name: "registration_number", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "ticket.delivered_date", name: "delivered_date", type: "date", required: false, margin: "normal", className: "col-12 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.A", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.A01", name: "complaint_categories.A01", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A02", name: "complaint_categories.A02", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A03", name: "complaint_categories.A03", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A04", name: "complaint_categories.A04", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A05", name: "complaint_categories.A05", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A06", name: "complaint_categories.A06", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A07", name: "complaint_categories.A07", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.A99", name: "complaint_categories.A99", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-0" },
	{ label: "ticket.complaint_categories.A100", name: "complaint_categories.A100", type: "text", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.F", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.F01", name: "complaint_categories.F01", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.F02", name: "complaint_categories.F02", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.F03", name: "complaint_categories.F03", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.F04", name: "complaint_categories.F04", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.F05", name: "complaint_categories.F05", type: "checkbox", className: "col-12 col-sm-12 col-lg-8 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.F99", name: "complaint_categories.F99", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-0" },
	{ label: "ticket.complaint_categories.F100", name: "complaint_categories.F100", type: "text", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.P", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.P01", name: "complaint_categories.P01", type: "checkbox", className: "col-12 col-sm-12 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.P99", name: "complaint_categories.P99", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-0" },
	{ label: "ticket.complaint_categories.P100", name: "complaint_categories.P100", type: "text", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.O", type: "header", className: "mt-3" },
	{ label: "ticket.complaint_categories.O01", name: "complaint_categories.O01", type: "checkbox", className: "col-12 col-sm-12 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_categories.O99", name: "complaint_categories.O99", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-0" },
	{ label: "ticket.complaint_categories.O100", name: "complaint_categories.O100", type: "text", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.complaint_description", name: "complaint_description", type: "textarea", required: true, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "dealer", type: "header", className: "mt-3" },
	{
		label: "dealer.dealer_name", name: "dealer_id", type: "dropdown", required: true, margin: "normal", className: "col-12 pr-2 mt-0 mb-2",
		options: []
	},
	{ label: "dealer.sale_manager_name", name: "dealer.sale_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{ label: "dealer.service_manager_name", name: "dealer.service_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{ label: "dealer.sale_area_manager_name", name: "dealer.sale_area_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
	{ label: "dealer.service_area_manager_name", name: "dealer.service_area_manager_name", type: "text", disabled: true, required: false, margin: "normal", className: "col-6 col-md-3 col-lg-3 pr-2 mt-0 mb-2" },
]

export const ticketManagementFormFields = [
	{
		label: "ticket.contacted_status", name: "contacted_status", type: "radiogroup", row: true, required: false, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.contacted_status.1", value: "1" },
			{ display: "ticket.contacted_status.0", value: "0" }
		]
	},
	{ label: "ticket.verify_by", name: "verify_by", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.problem_solved_status", name: "problem_solved_status", type: "radiogroup", row: true, required: false, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.problem_solved_status.1", value: "1" },
			{ display: "ticket.problem_solved_status.0", value: "0" },
			{ display: "ticket.problem_solved_status.2", value: "2" }
		]
	},
	{ label: "ticket.problem_solved_detail", name: "problem_solved_detail", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.satisfied", name: "satisfied", type: "radiogroup", row: true, required: false, disabled: false, margin: "normal", className: "col-12 pr-2 mt-4 mb-0",
		options: [
			{ display: "ticket.satisfied.Y", value: "Y" },
			{ display: "ticket.satisfied.N", value: "N" },
			{ display: "ticket.satisfied.NA", value: "NA" },
		]
	},
	{ label: "ticket.closed_loop_date", name: "closed_loop_date", type: "textarea", required: false, disabled: true, multiline: true, rows: 1, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.unsatisfied", name: "unsatisfied", type: "textarea", required: false, disabled: true, multiline: true, rows: 1, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.customer_voc", name: "customer_voc", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.recieved_satisfied_sms_status", name: "recieved_satisfied_sms_status", type: "radiogroup", row: true, required: false, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.recieved_satisfied_sms_status.1", value: "1" },
			{ display: "ticket.recieved_satisfied_sms_status.0", value: "0" }
		]
	},
	{ label: "ticket.recieved_satisfied_sms_detail", name: "recieved_satisfied_sms_detail", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.problem_solved_suitable_status", name: "problem_solved_suitable_status", type: "radiogroup", row: true, required: false, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.problem_solved_suitable_status.1", value: "1" },
			{ display: "ticket.problem_solved_suitable_status.0", value: "0" }
		]
	},
	{ label: "ticket.problem_solved_suitable_status_detail", name: "problem_solved_suitable_status_detail", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.review_status", name: "review_status", type: "radiogroup", row: true, required: false, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.review_status.1", value: "1" },
			{ display: "ticket.review_status.0", value: "0" }
		]
	},
	{ label: "ticket.review_detail", name: "review_detail", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.solution_categories", type: "title", className: "col-12 mt-3" },
	{ label: "ticket.solution_categories.S01", name: "solution_categories.S01", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.solution_categories.S02", name: "solution_categories.S02", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.solution_categories.S03", name: "solution_categories.S03", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.solution_categories.S04", name: "solution_categories.S04", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.solution_categories.S05", name: "solution_categories.S05", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.solution_categories.S99", name: "solution_categories.S99", type: "checkbox", className: "col-12 col-sm-6 col-lg-12 pr-2 mt-0 mb-0" },
	{ label: "ticket.solution_categories.S100", name: "solution_categories.S100", type: "text", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "ticket.case_categories", type: "title", className: "col-12 mt-3" },
	{
		label: "ticket.sub_category", name: "sub_category", type: "dropdown", required: false, margin: "normal", className: "col-12 pr-2 mt-3 mb-2",
		options: []
	},
	{
		label: "ticket.problem_list", name: "problem_list", type: "dropdown", required: false, margin: "normal", className: "col-12 pr-2 mt-3 mb-2",
		options: []
	},
	{ label: "ticket.remark_ticket_closed", name: "remark_ticket_closed", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.verify", type: "header", className: "mt-4" },
	{
		label: "ticket.verify_status", name: "verify_status", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-3 col-sm-6 pr-2 mt-0 mb-4",
		options: [
			{ display: "ticket.verify_status.na", value: "na" },
			{ display: "ticket.verify_status.valid", value: "valid" },
			{ display: "ticket.verify_status.invalid", value: "invalid" }
		]
	},
	{ label: "ticket.remark", name: "remark", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.crm_case_no", name: "crm_case_no", type: "text", required: false, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
]

export const ticketManagementV1FormFields = [
	{ label: "ticket.verify", type: "header" },
	{
		label: "ticket.satisfied_v1", name: "satisfied", type: "radiogroup", row: true, required: true, margin: "normal", className: "col-12 pr-2 mt-0 mb-2",
		options: [
			{ display: "ticket.satisfied.Y", value: "Y" },
			{ display: "ticket.satisfied.N", value: "N" }
		]
	},
	{ label: "ticket.customer_voc_v1", name: "customer_voc", type: "textarea", required: true, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.review_status_v1", name: "review_status", type: "radiogroup", row: true, required: true, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.review_status.1", value: "1" },
			{ display: "ticket.review_status.0", value: "0" }
		]
	},
	{ label: "ticket.review_detail_v1", name: "review_detail", type: "textarea", required: true, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.contacted_status_v1", name: "contacted_status", type: "radiogroup", row: true, required: true, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.contacted_status.1", value: "1" },
			{ display: "ticket.contacted_status.0", value: "0" }
		]
	},
	{ label: "ticket.verify_by_v1", name: "verify_by", type: "textarea", required: true, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.recieved_satisfied_sms_status_v1", name: "recieved_satisfied_sms_status", type: "radiogroup", row: true, required: true, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.recieved_satisfied_sms_status.1", value: "1" },
			{ display: "ticket.recieved_satisfied_sms_status.0", value: "0" }
		]
	},
	{ label: "ticket.recieved_satisfied_sms_detail_v1", name: "recieved_satisfied_sms_detail", type: "textarea", required: true, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
]

export const ticketManagementV2FormFields = [
	{
		label: "ticket.contacted_status", name: "contacted_status", type: "radiogroup", row: true, required: false, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.contacted_status.1", value: "1" },
			{ display: "ticket.contacted_status.0", value: "0" }
		]
	},
	{ label: "ticket.verify_by", name: "verify_by", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.problem_solved_status", name: "problem_solved_status", type: "radiogroup", row: true, required: false, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.problem_solved_status.1", value: "1" },
			{ display: "ticket.problem_solved_status.0", value: "0" }
		]
	},
	{ label: "ticket.problem_solved_detail", name: "problem_solved_detail", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.satisfied", name: "satisfied", type: "radiogroup", row: true, required: false, disabled: false, margin: "normal", className: "col-12 pr-2 mt-4 mb-0",
		options: [
			{ display: "ticket.satisfied.Y", value: "Y" },
			{ display: "ticket.satisfied.N", value: "N" },
			{ display: "ticket.satisfied.NA", value: "NA" },
		]
	},
	{ label: "ticket.unsatisfied", name: "unsatisfied", type: "textarea", required: false, disabled: true, multiline: true, rows: 1, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.customer_voc", name: "customer_voc", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.recieved_satisfied_sms_status", name: "recieved_satisfied_sms_status", type: "radiogroup", row: true, required: false, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.recieved_satisfied_sms_status.1", value: "1" },
			{ display: "ticket.recieved_satisfied_sms_status.0", value: "0" }
		]
	},
	{ label: "ticket.recieved_satisfied_sms_detail", name: "recieved_satisfied_sms_detail", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.problem_solved_suitable_status", name: "problem_solved_suitable_status", type: "radiogroup", row: true, required: false, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.problem_solved_suitable_status.1", value: "1" },
			{ display: "ticket.problem_solved_suitable_status.0", value: "0" }
		]
	},
	{ label: "ticket.problem_solved_suitable_status_detail", name: "problem_solved_suitable_status_detail", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{
		label: "ticket.review_status", name: "review_status", type: "radiogroup", row: true, required: false, margin: "normal", className: "col-12 pr-2 mt-4 mb-2",
		options: [
			{ display: "ticket.review_status.1", value: "1" },
			{ display: "ticket.review_status.0", value: "0" }
		]
	},
	{ label: "ticket.review_detail", name: "review_detail", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
	{ label: "ticket.verify", type: "header", className: "mt-4" },
	{
		label: "ticket.verify_status", name: "verify_status", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-4 col-md-3 col-sm-6 pr-2 mt-0 mb-4",
		options: [
			{ display: "ticket.verify_status.na", value: "na" },
			{ display: "ticket.verify_status.valid", value: "valid" },
			{ display: "ticket.verify_status.invalid", value: "invalid" }
		]
	},
	{ label: "ticket.remark", name: "remark", type: "textarea", required: false, multiline: true, rows: 3, rowsMax: 5, margin: "normal", className: "col-12  pr-2 mt-0 mb-2" },
]

export const userSearchFormFields = [
	{ label: "user.first_name", name: "first_name", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "user.last_name", name: "last_name", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "user.email", name: "email", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{
		label: "user.type", name: "type", type: "dropdown", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "user.type.nissan", value: "nissan" },
			{ display: "user.type.nml", value: "nml" },
			{ display: "user.type.region_manager", value: "region_manager" },
			{ display: "user.type.area_manager", value: "area_manager" },
			{ display: "user.type.csn", value: "csn" },
			{ display: "user.type.callcenter", value: "callcenter" },
			{ display: "user.type.dealer", value: "dealer" },
			{ display: "user.type.external", value: "external" }
		]
	},
]

export const userFormFields = [
	{ label: "user.first_name", name: "first_name", type: "text", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "user.last_name", name: "last_name", type: "text", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "user.email", name: "email", type: "text", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "user.password", name: "password", type: "text", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "user.mobile", name: "mobile", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{ label: "user.position_title", name: "position_title", type: "text", required: false, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2" },
	{
		label: "user.active_flag", name: "active_flag", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "user.active_flag.1", value: "1" },
			{ display: "user.active_flag.0", value: "0" },
		]
	},
	{
		label: "user.type", name: "type", type: "dropdown", required: true, margin: "normal", className: "col-6 col-lg-3 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "user.type.nissan", value: "nissan" },
			{ display: "user.type.nml", value: "nml" },
			{ display: "user.type.region_manager", value: "region_manager" },
			{ display: "user.type.area_manager", value: "area_manager" },
			{ display: "user.type.csn", value: "csn" },
			{ display: "user.type.callcenter", value: "callcenter" },
			{ display: "user.type.external", value: "external" }
		]
	},
	{ label: "user.group", type: "header", className: "mt-3" },
	{ label: "user.group.showroom", name: "group.showroom", type: "checkbox", className: "col-12 col-sm-6 col-lg-6 pr-2 mt-0 mb-2" },
	{ label: "user.group.service", name: "group.service", type: "checkbox", className: "col-12 col-sm-6 col-lg-6 pr-2 mt-0 mb-2" },
	{
		label: "dealer.dealer_sales_region", name: "dealer_sales_region", type: "dropdown", required: true, margin: "normal", className: "col-6  col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_sales_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_sales_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_sales_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_sales_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_sales_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_sales_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.dealer_service_region", name: "dealer_service_region", type: "dropdown", required: true, margin: "normal", className: "col-6  col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		default: { display: "dealer.dealer_service_region.all", value: "all" },
		options: [
			{ display: "dealer.dealer_service_region.Region1", value: "REGION 1" },
			{ display: "dealer.dealer_service_region.Region2", value: "REGION 2" },
			{ display: "dealer.dealer_service_region.Region3", value: "REGION 3" },
			{ display: "dealer.dealer_service_region.Region4", value: "REGION 4" },
			{ display: "dealer.dealer_service_region.Region5", value: "REGION 5" }
		]
	},
	{
		label: "dealer.sale_area_code", name: "sale_area_code", type: "dropdown", required: true, margin: "normal", className: "col-6  col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "dealer.sale_area_code.R1-1", value: "R1-1" },
			{ display: "dealer.sale_area_code.R1-2", value: "R1-2" },
			{ display: "dealer.sale_area_code.R1-3", value: "R1-3" },
			{ display: "dealer.sale_area_code.R1-4", value: "R1-4" },
			{ display: "dealer.sale_area_code.R2-1", value: "R2-1" },
			{ display: "dealer.sale_area_code.R2-2", value: "R2-2" },
			{ display: "dealer.sale_area_code.R2-3", value: "R2-3" },
			{ display: "dealer.sale_area_code.R3-1", value: "R3-1" },
			{ display: "dealer.sale_area_code.R3-2", value: "R3-2" },
			{ display: "dealer.sale_area_code.R3-3", value: "R3-3" },
			{ display: "dealer.sale_area_code.R4-1", value: "R4-1" },
			{ display: "dealer.sale_area_code.R4-2", value: "R4-2" },
			{ display: "dealer.sale_area_code.R4-3", value: "R4-3" },
			{ display: "dealer.sale_area_code.R5-1", value: "R5-1" },
			{ display: "dealer.sale_area_code.R5-2", value: "R5-2" },
			{ display: "dealer.sale_area_code.R5-3", value: "R5-3" },
		]
	},
	{
		label: "dealer.service_area_code", name: "service_area_code", type: "dropdown", required: true, margin: "normal", className: "col-6 col-md-6 col-sm-6 pr-2 mt-0 mb-2",
		options: [
			{ display: "dealer.service_area_code.R1-1", value: "R1-1" },
			{ display: "dealer.service_area_code.R1-2", value: "R1-2" },
			{ display: "dealer.service_area_code.R1-3", value: "R1-3" },
			{ display: "dealer.service_area_code.R1-4", value: "R1-4" },
			{ display: "dealer.service_area_code.R2-1", value: "R2-1" },
			{ display: "dealer.service_area_code.R2-2", value: "R2-2" },
			{ display: "dealer.service_area_code.R2-3", value: "R2-3" },
			{ display: "dealer.service_area_code.R2-4", value: "R2-4" },
			{ display: "dealer.service_area_code.R3-1", value: "R3-1" },
			{ display: "dealer.service_area_code.R3-2", value: "R3-2" },
			{ display: "dealer.service_area_code.R3-3", value: "R3-3" },
			{ display: "dealer.service_area_code.R4-1", value: "R4-1" },
			{ display: "dealer.service_area_code.R4-2", value: "R4-2" },
			{ display: "dealer.service_area_code.R4-3", value: "R4-3" },
			{ display: "dealer.service_area_code.R4-4", value: "R4-4" },
			{ display: "dealer.service_area_code.R5-1", value: "R5-1" },
			{ display: "dealer.service_area_code.R5-2", value: "R5-2" },
			{ display: "dealer.service_area_code.R5-3", value: "R5-3" },
		]
	},
	{ label: "user.permission", type: "header", className: "mt-3" },
	{ label: "user.permission.ticket_validation", name: "permission.ticket_validation", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "user.permission.ticket_validation_closed_edit", name: "permission.ticket_validation_closed_edit", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "user.permission.bp", type: "header", className: "mt-3" },
	{ label: "user.permission.bp_dashboard", name: "permission.bp_dashboard", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
	{ label: "user.permission.bp_report", name: "permission.bp_report", type: "checkbox", className: "col-12 col-sm-6 col-lg-4 pr-2 mt-0 mb-2" },
]